import { render, staticRenderFns } from "./LuckDrawRecord.vue?vue&type=template&id=3bd395f6&scoped=true&"
import script from "./LuckDrawRecord.vue?vue&type=script&lang=js&"
export * from "./LuckDrawRecord.vue?vue&type=script&lang=js&"
import style0 from "./LuckDrawRecord.vue?vue&type=style&index=0&id=3bd395f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd395f6",
  null
  
)

export default component.exports